<template>
    <div>
        <div class="answer-form__actions">
            <slot name="actions"></slot>
            <a href="#" class="file-upload__add-trigger" @click.prevent="addFile">Attach a file</a>
        </div>
        <div class="question-view__attachments" v-show="files.files.length">
            <div v-for="(file, fileIndex) in files.files" :key="fileIndex" >
                <file-or-picture :file="file" :fileIndex="fileIndex" @delete-file="removeFile(fileIndex)"></file-or-picture>
            </div>
        </div>
    </div>
</template>

<script>
    import FileOrPicture from './FileOrPicture'
    export default {
        name: 'FilesList',
        components: {
            FileOrPicture
        },
        data: function () {
            return {
                files: {
                    files: [],
                    deleted: []
                }
            };
        },
        props: {
            value: Object
        },
        computed: {
            any: function () {
                return this.files.length;
            }
        },
        methods: {
            addFile: function () {
                this.files.files.push({});
            },
            removeFile: function (index) {
                let file = this.files.files[index];
                if (file.id) {
                    this.files.deleted.push(this.files.files[index]);
                }
                this.files.files.splice(index, 1);
            }
        },
        mounted: function () {
            if (this.value) {
                this.$set(this.files, 'files', this.value.files);
                this.$set(this.files, 'deleted', this.value.deleted);
            }
        },
        watch: {
            value: function (newValue) {
                this.$set(this.files, 'files', newValue.files);
                this.$set(this.files, 'deleted', newValue.deleted);
            },
            files: {
                handler: function (newValue) {
                    this.$root.$emit('updateFiles', newValue);
                    this.$emit('input', this.files);
                    this.$emit('change', this.files);
                },
                deep: true
            }
        }
    }
</script>